import { opsContext, useCreateOpsContext } from '@/pages/operations/ops-context.context'

export const OpsContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const context = useCreateOpsContext()
  return <opsContext.Provider value={context}>{children}</opsContext.Provider>
}
